<template>
  <div id="itemSystem">
    <div class="container">
      产品体系管理
      <el-select v-model="query.type" placeholder="请选择类别" clearable @change="getProductList()" style="margin-right:0.520833rem">
    <el-option
      v-for="item in selectList"
      :key="item.id"
      :label="item.typeName"
      :value="item.id">
    </el-option>
      </el-select>
      <el-button
        type="danger"
        icon="el-icon-delete"
        @click="handleDelete(deleteArr)"
        >批量删除</el-button
      >
      <el-button type="success" @click="addNew()">添加产品体系</el-button>
      <el-table
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column prop="type" label="体系类别"> 
          <template slot-scope="scope">
            {{scope.row.typeName}}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题"> 
          <template slot-scope="scope">
            {{scope.row.title}}
          </template>
          
        </el-table-column>
        <el-table-column prop="title" label="未选中标识">
          <template slot-scope="scope">
            <el-image
              style="width: 1.041666rem; height: 1.041666rem"
              v-if="scope.row.sysPictureNs"
              :src="
                scope.row.sysPictureNs
                  ? baseURL +
                    scope.row.sysPictureNs['fileUrl'] +
                    scope.row.sysPictureNs['newName']
                  : ''
              "
              :preview-src-list="
                scope.row.sysPictureNs
                  ? [
                      baseURL +
                        scope.row.sysPictureNs['fileUrl'] +
                        scope.row.sysPictureNs['newName'],
                    ]
                  : []
              "
              alt=""
            >
            </el-image>

          </template>
        </el-table-column>
          <el-table-column prop="title" label="已选中标识">
          <template slot-scope="scope">
            <el-image
              style="width: 1.041666rem; height: 1.041666rem"
              v-if="scope.row.sysPictureIs"
              :src="
                scope.row.sysPictureIs
                  ? baseURL +
                    scope.row.sysPictureIs['fileUrl'] +
                    scope.row.sysPictureIs['newName']
                  : ''
              "
              :preview-src-list="
                scope.row.sysPictureIs
                  ? [
                      baseURL +
                        scope.row.sysPictureIs['fileUrl'] +
                        scope.row.sysPictureIs['newName'],
                    ]
                  : []
              "
              alt=""
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序"> </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          
        >
          <template slot-scope="scope">
            {{ scope.row.updateTime | seTimeFilter("sjx") }}
          </template>
        </el-table-column>
      
        <!-- <el-table-column prop="title" label="未选中标识">
          <template slot-scope="scope">
            <el-image
              style="width: 20px; height: 20px"
              :src="
                scope.row.iconUcP
                  ? baseURL +
                    scope.row.iconUcP['fileUrl'] +
                    scope.row.iconUcP['newName']
                  : ''
              "
              :preview-src-list="
                scope.row.iconUcP
                  ? [
                      baseURL +
                        scope.row.iconUcP['fileUrl'] +
                        scope.row.iconUcP['newName'],
                    ]
                  : []
              "
              alt=""
            >
            </el-image>
          </template>
        </el-table-column>
          <el-table-column prop="title" label="已选中标识">
          <template slot-scope="scope">
            <el-image
              style="width: 20px; height: 20px"
              :src="
                scope.row.iconCP
                  ? baseURL +
                    scope.row.iconCP['fileUrl'] +
                    scope.row.iconCP['newName']
                  : ''
              "
              :preview-src-list="
                scope.row.iconCP
                  ? [
                      baseURL +
                        scope.row.iconCP['fileUrl'] +
                        scope.row.iconCP['newName'],
                    ]
                  : []
              "
              alt=""
            >
            </el-image>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="addNew(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              @click="handleDelete(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageNo"
          :page-size="query.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  productListApi,
  delSysProduct,
  addSysProduct,
  editSysProduct,
  listProductType
} from "@/api/manage";
import config from "@/config/url.config";
export default {
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
        type:''
       // sortType: "a",
      },
      baseURL: config.baseURL,
      pageTotal: 0,
      dialogVisible: false,
      tableData: [],
      deleteArr: [],
      isEdit: false,
      editId: "",
      key: 1,
      selectList:[]
    };
  },
  created() {
    this.getProductList();
    this.getlistProductType()
  },
  mounted() {},
  methods: {
    async getProductList() {
      //获取产品体系列表
      let res = await productListApi(this.query);
      if (res.code == "200") {
        this.tableData = res.data;
        this.pageTotal = +res.total;
      }else{
        this.tableData =[]
        this.pageTotal =0
      }
    },
    async getlistProductType(){
      let res = await listProductType({pageNo:1,pageSize:999})
       this.selectList=res.data
    },
    handleDelete(ids) {
      //删除以及批量删除
      if (ids.length == 0) {
        return this.$message.error("未选择删除项");
      }
      this.$confirm("此操作将永久删除该体系, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let param = {};
          if (ids.length == 0) {
            param.ids = "";
          } else {
            param.ids = Array.isArray(ids)
              ? JSON.stringify(ids)
              : JSON.stringify([ids]);
          }
          let res = await delSysProduct(param);
          if (res.code == 200) {
            if (JSON.parse(param.ids).length == this.tableData.length) {
              this.query.pageNo--;
            }
            this.$message.success("删除成功！");
            this.getProductList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSelectionChange(val) {
      //多选操作,批量删除
      this.deleteArr = [];
      val.map((item) => {
        this.deleteArr.push(item.id);
      });
    },
    addNew(data) {
      //新增产品体系,编辑产品体系
      console.log('data变价',data);
      if (!data) {
        this.$router.replace({
          name: "itemSystemAdd",
          params: { typeOf: "add",total:this.pageTotal, },
        });
      } else {
         let replaceTxt = 'http://116.206.94.117:8195//uploading'
      let newTxt = 'http://101.89.182.189:8191//uploading'
      let text = encodeURI(decodeURI(data.text).replace(new RegExp(replaceTxt,'g'),newTxt));
        this.$router.replace({
          name: "itemSystemAdd",
          params: {
            typeOf: "edit",
            id: data.id,
            title: data.title,
            type: data.type,
            text: text,
            picIs:data.picIs,
            picNs:data.picNs,
            sort:data.sort
          },
        });
      }
    },
    handleClose(done) {
      done();
      this.$refs["ruleForm"].resetFields();
    },
    handlePageChange(val) {
      this.$set(this.query, "pageNo", val);
      this.getProductList();
    },
    sortChange() {
      this.query.sortType
        ? (this.query.sortType = "")
        : (this.query.sortType = "a");
      this.getProductList();
    },
  },
  watch: {
    "ruleForm.pictureId": function (newValue, oldValue) {
      let reg = /(^[1-9]\d*$)/; //插图id只能输入正整数
      if (reg.test(newValue)) {
        this.ruleForm.pictureId = newValue;
      } else if (newValue !== "") {
        this.ruleForm.pictureId = oldValue;
      }
    },
  },
};
</script>

<style lang="less" scoped>
#itemSystem {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.red {
  color: #f56c6c;
}
.el-table /deep/ th {
  overflow: unset;
}
</style>